export default {
    default_node_code: `
        const { Kafka } = require('kafkajs');

        const kafka = new Kafka({
            clientId: 'my-app',
            brokers: ['<your-bootstrap-servers>']  // Update with your broker address
        });
        
        const consumer = kafka.consumer({ groupId: 'test-group' });
        
        const run = async () => {
        await consumer.connect();
        await consumer.subscribe({ topic: '<your-topic>', fromBeginning: true });
        
        await consumer.run({
            eachMessage: async ({ topic, partition, message }) => {
            console.log({
                partition,
                offset: message.offset,
                value: message.value.toString(),
            });
            },
        });
        };
        
        run().catch(console.error);
    
    `,

    default_python_code: `
    from kafka import KafkaConsumer

    # Replace 'your-topic' with your Kafka topic and broker address
    consumer = KafkaConsumer(
        '<your-topic>',
        bootstrap_servers=['<your-bootstrap-servers>'],  # Update with your broker address
        auto_offset_reset='earliest',
        group_id='my-group'
    )

    for message in consumer:
        print(f"Partition: {message.partition}, Offset: {message.offset}, Value: {message.value.decode('utf-8')}")
    }`,

    default_java_code: `
    import org.apache.kafka.clients.consumer.ConsumerConfig;
    import org.apache.kafka.clients.consumer.ConsumerRecords;
    import org.apache.kafka.clients.consumer.KafkaConsumer;
    import org.apache.kafka.clients.consumer.ConsumerRecord;
    import org.apache.kafka.common.serialization.StringDeserializer;

    import java.time.Duration;
    import java.util.Collections;
    import java.util.Properties;

    public class KafkaConsumerExample {
        public static void main(String[] args) {
            // Configure Kafka consumer properties
            Properties properties = new Properties();
            properties.put(ConsumerConfig.BOOTSTRAP_SERVERS_CONFIG, "<your-bootstrap-servers>"); // Replace with your broker address
            properties.put(ConsumerConfig.GROUP_ID_CONFIG, "example-group");           // Consumer group ID
            properties.put(ConsumerConfig.KEY_DESERIALIZER_CLASS_CONFIG, StringDeserializer.class.getName());
            properties.put(ConsumerConfig.VALUE_DESERIALIZER_CLASS_CONFIG, StringDeserializer.class.getName());
            properties.put(ConsumerConfig.AUTO_OFFSET_RESET_CONFIG, "earliest");       // Read from the beginning

            // Create Kafka consumer
            KafkaConsumer<String, String> consumer = new KafkaConsumer<>(properties);

            // Subscribe to the topic
            String topic = "<your-topic>"; // Replace with your topic name
            consumer.subscribe(Collections.singletonList(topic));

            // Poll for new data
            try {
                while (true) {
                    // Set the polling timeout
                    ConsumerRecords<String, String> records = consumer.poll(Duration.ofMillis(1000));

                    for (ConsumerRecord<String, String> record : records) {
                        System.out.printf("Offset: %d, Key: %s, Value: %s%n", record.offset(), record.key(), record.value());
                    }
                }
            } catch (Exception e) {
                e.printStackTrace();
            } finally {
                // Close the consumer gracefully
                consumer.close();
            }
        }
        }
    `,

    default_rust_code: `
    use futures::StreamExt;
    use rdkafka::config::ClientConfig;
    use rdkafka::consumer::{Consumer, StreamConsumer};
    use rdkafka::error::KafkaResult;
    use rdkafka::message::Message;
    use rdkafka::consumer::CommitMode;
    use rdkafka::util::get_rdkafka_version;

    #[tokio::main]
    async fn main() -> KafkaResult<()> {
        let (version_n, version_s) = get_rdkafka_version();
        println!("rd_kafka version: 0x{:08x}, {}", version_n, version_s);

        // Define Kafka configuration
        let brokers = "localhost:9092"; // Replace with your Kafka broker(s)
        let group_id = "example-group";
        let topic = "<your-topic>"; // Replace with your topic name

        // Create a consumer configuration
        let consumer: StreamConsumer = ClientConfig::new()
            .set("bootstrap.servers", <your-bootstrap-servers>)
            .set("group.id", group_id)
            .set("auto.offset.reset", "earliest")
            .create()
            .expect("Consumer creation failed");

        // Subscribe to the specified topic
        consumer.subscribe(&[topic]).expect("Failed to subscribe to topic");

        println!("Subscribed to topic: {}", topic);

        // Process message stream
        let mut message_stream = consumer.stream();

        while let Some(message) = message_stream.next().await {
            match message {
                Err(e) => eprintln!("Error while reading from stream: {:?}", e),
                Ok(m) => {
                    if let Some(payload) = m.payload_view::<str>().unwrap_or_else(|_| None) {
                        println!("Received message: {}", payload);
                    } else {
                        println!("Received message with no payload");
                    }
                    
                    // Optionally, commit the message's offset
                    consumer.commit_message(&m, CommitMode::Async).unwrap();
                }
            }
        }

        Ok(())
        }
    `,

    default_cobol_code: `
            IDENTIFICATION DIVISION.
            PROGRAM-ID. KAFKA-READER.

            ENVIRONMENT DIVISION.
            INPUT-OUTPUT SECTION.
            FILE-CONTROL.
                SELECT MESSAGE-FILE ASSIGN TO 'kafka_messages.txt'
                    ORGANIZATION IS LINE SEQUENTIAL.

            DATA DIVISION.
            FILE SECTION.
            FD  MESSAGE-FILE.
            01  MESSAGE-RECORD PIC X(100).

            WORKING-STORAGE SECTION.
            01  WS-END-OF-FILE    PIC X VALUE 'N'.

            PROCEDURE DIVISION.
            MAIN-LOGIC.
                OPEN INPUT MESSAGE-FILE
                PERFORM UNTIL WS-END-OF-FILE = 'Y'
                    READ MESSAGE-FILE INTO MESSAGE-RECORD
                        AT END
                            MOVE 'Y' TO WS-END-OF-FILE
                        NOT AT END
                            DISPLAY 'Message: ' MESSAGE-RECORD
                    END-READ
                END-PERFORM
                CLOSE MESSAGE-FILE
                STOP RUN.
    `,
    stock_topic: 'stock-topic',
    stock_bootstrap_servers: 'localhost:9092',
    inventory_topic: 'inventory-topic',
    inventory_bootstrap_servers: 'localhost:9092',
    pizza_topic: 'pizza-topic',
    pizza_bootstrap_servers: 'localhost:9092',
    stock_websocket: 'wss://prod-event-mock.gateway.apim.event-mock.gravitee.xyz/stocks/',
    pizza_websocket: 'wss://prod-event-mock.gateway.apim.event-mock.gravitee.xyz/pizza-orders/',
    inventory_websocket: 'wss://prod-event-mock.gateway.apim.event-mock.gravitee.xyz/inventory/'
}